import { Proration } from "../Proration";
import {
  useUpgradeFlowFormContext,
  useUpgradeFlowShellContext,
} from "../UpgradeFlowContext";

export const ProrationRoute = () => {
  const { modal } = useUpgradeFlowShellContext();
  const { onSubmitHandler } = useUpgradeFlowFormContext();

  return (
    <Proration
      hideModal={modal.hide}
      onSubmitHandler={() => onSubmitHandler()}
    />
  );
};
